import { Button, Form, Input, message } from "antd";
import Typography from "app/shared/Typography";
import EmailUpdateForm from "./EmailUpdate";
import { useEffect, useState } from "react";
import { apiPost } from "app/services/apiServices";
import InvalidEmailForm from "./InvalidEmailUpdate";
export default function HotelDataUpdate({ type, contactDetails, onSuccess, segmentType, onDataRefresh, onRowDataUpdate }) {
  // const [hotelEmails, setHotelEmails] = useState([]);
  const [hotelNumbers, setHotelNumbers] = useState([]);
  const [hotelBookingId, setHotelBookingId] = useState("");
  const [hotelName, setHotelName] = useState("")
  const [isLoading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [client, setClient] = useState("");
  const [gstin, setGstin] = useState("")
  const [legalName, setLegalName] = useState("")
  const [pincode, setPincode] = useState("")
  const [country, setCountry] = useState("India")
  const [address, setAddress] = useState("")
  const [locality, setLocality] = useState("")
  const [invalidEmails, setInvalidEmails] = useState(contactDetails?.email_hotel_contact_invalid_email || []);

  const [hotelEmails, setHotelEmails] = useState([...new Set(contactDetails?.email_hotel_contact_email || [])]);

  useEffect(() => {

    if (contactDetails) {
      setHotelBookingId(contactDetails?.email_bookingId || "");
      setHotelName(contactDetails?.email_hotel_name || contactDetails?.airline_name);
      setState(contactDetails?.email_hotel_state || "");
      setCity(contactDetails?.email_hotel_city || "");
      setClient(contactDetails?.booking_client_id || "");
      setGstin(contactDetails?.email_hotel_gstin || "")
      setLegalName(contactDetails?.email_hotel_legal_name || "");
      setPincode(contactDetails.pincode || "")
      setCountry(contactDetails?.email_hotel_country || "India")
      setAddress(contactDetails?.email_hotel_address || "")
      setLocality(contactDetails?.email_hotel_locality || "")
      // setInvalidEmails(contactDetails?.email_hotel_contact_invalid_email || []);
      setInvalidEmails(
        Array.isArray(contactDetails?.email_hotel_contact_invalid_email)
          ? contactDetails.email_hotel_contact_invalid_email.map(email => email)
          : []
      );
      if (type === "email") {
        setHotelEmails([...new Set(contactDetails?.email_hotel_contact_email || [])]);
      } else if (type === "phone") {
        setHotelNumbers(contactDetails?.email_hotel_contact_phone || []);
      }
    }
  }, [contactDetails, type]);
  const handleSubmitHotelInfo = async () => {
    setLoading(true);
  
    const emails = (hotelEmails || []).filter(Boolean);
    const numbers = (hotelNumbers || []).filter(Boolean);
  
    const vendorType = segmentType === "AIRLINE" ? "Airline" : "Hotel";
  
    const payload = {
      hotelName,
      state,
      client,
      city,
      gstin,
      pincode,
      country,
      address,
      legalName,
      locality,
      hotelBookingId: hotelBookingId || "",
      hotel_emails: emails,
      hotel_phone_numbers: numbers,
      invalidEmails,
      vendorType,
    };
  
    try {
      const response = await apiPost(
        "https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/detailsUpdate",
        payload
      );
  
      if (response.status) {
        messageApi.success({
          type: "success",
          content: "Hotel details updated",
        });
  
        if (onRowDataUpdate) {
          onRowDataUpdate({
            ...contactDetails,
            email_hotel_contact_email: emails,
            email_hotel_contact_phone: numbers,
            email_hotel_contact_invalid_email: invalidEmails,
            email_hotel_gstin: gstin,
          });
        } else if (onDataRefresh) {
          onDataRefresh();
        }
  
        onSuccess();
      } else {
        messageApi.error({
          type: "error",
          content: "Could not update hotel detail",
        });
      }
    } catch (error) {
      messageApi.error({
        type: "error",
        content: "Something went wrong while updating hotel details",
      });
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="HotelUpdateForm" style={{ display: "flex", flexDirection: "column" }}>
      <Form name="basic" autoComplete="off" style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
        {/* Scrollable fields */}
        <div style={{ maxHeight: "60vh", overflowY: "auto", paddingRight: 4 }}>
        {/* Hotel Name — read only */}
        <div style={{ marginBottom: 16 }}>
          <Typography variant="xs" style={{ marginBottom: 4 }}>
            Hotel Name
          </Typography>
          <div
            style={{
              padding: "6px 11px",
              background: "#f5f5f5",
              border: "1px solid #d9d9d9",
              borderRadius: 6,
              color: "#555",
              fontSize: 14,
            }}
          >
            {hotelName || "—"}
          </div>
        </div>

        {/* Legal Name — editable */}
        <div style={{ marginBottom: 16 }}>
          <Typography variant="xs" style={{ marginBottom: 4 }}>
            Legal Name
          </Typography>
          <Input
            value={legalName}
            onChange={(e) => setLegalName(e.target.value)}
            placeholder="Enter Legal Name"
          />
        </div>

        {/* GSTIN — editable */}
        <div style={{ marginBottom: 16 }}>
          <Typography variant="xs" style={{ marginBottom: 4 }}>
            GSTIN
          </Typography>
          <Input
            value={gstin}
            onChange={(e) => setGstin(e.target.value)}
            placeholder="Enter GSTIN"
          />
        </div>

        {/* Hotel Address */}
        <div style={{ marginBottom: 16 }}>
          <Typography variant="xs" style={{ marginBottom: 4 }}>Hotel Address</Typography>
          {contactDetails?.email_hotel_address ? (
            <div style={{ padding: "6px 11px", background: "#f5f5f5", border: "1px solid #d9d9d9", borderRadius: 6, color: "#555", fontSize: 14 }}>
              {address || "—"}
            </div>
          ) : (
            <Input.TextArea value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Enter Hotel Address" rows={2} />
          )}
        </div>

        {/* Locality */}
        <div style={{ marginBottom: 16 }}>
          <Typography variant="xs" style={{ marginBottom: 4 }}>Locality</Typography>
          {contactDetails?.email_hotel_locality ? (
            <div style={{ padding: "6px 11px", background: "#f5f5f5", border: "1px solid #d9d9d9", borderRadius: 6, color: "#555", fontSize: 14 }}>
              {locality || "—"}
            </div>
          ) : (
            <Input value={locality} onChange={(e) => setLocality(e.target.value)} placeholder="Enter Locality" />
          )}
        </div>

        {/* State & City */}
        <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
          <div style={{ flex: 1 }}>
            <Typography variant="xs" style={{ marginBottom: 4 }}>State</Typography>
            {contactDetails?.email_hotel_state ? (
              <div style={{ padding: "6px 11px", background: "#f5f5f5", border: "1px solid #d9d9d9", borderRadius: 6, color: "#555", fontSize: 14 }}>
                {state || "—"}
              </div>
            ) : (
              <Input value={state} onChange={(e) => setState(e.target.value)} placeholder="Enter State" />
            )}
          </div>
          <div style={{ flex: 1 }}>
            <Typography variant="xs" style={{ marginBottom: 4 }}>City</Typography>
            {contactDetails?.email_hotel_city ? (
              <div style={{ padding: "6px 11px", background: "#f5f5f5", border: "1px solid #d9d9d9", borderRadius: 6, color: "#555", fontSize: 14 }}>
                {city || "—"}
              </div>
            ) : (
              <Input value={city} onChange={(e) => setCity(e.target.value)} placeholder="Enter City" />
            )}
          </div>
        </div>

        {/* Pincode & Country */}
        <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
          <div style={{ flex: 1 }}>
            <Typography variant="xs" style={{ marginBottom: 4 }}>Pincode</Typography>
            {contactDetails?.pincode ? (
              <div style={{ padding: "6px 11px", background: "#f5f5f5", border: "1px solid #d9d9d9", borderRadius: 6, color: "#555", fontSize: 14 }}>
                {pincode || "—"}
              </div>
            ) : (
              <Input value={pincode} onChange={(e) => setPincode(e.target.value)} placeholder="Enter Pincode" />
            )}
          </div>
          <div style={{ flex: 1 }}>
            <Typography variant="xs" style={{ marginBottom: 4 }}>Country</Typography>
            <Input value={country} onChange={(e) => setCountry(e.target.value)} placeholder="Enter Country" />
          </div>
        </div>

        {/* Emails */}
        <div style={{ marginBottom: 24 }}>
          <Typography variant="xs" style={{ marginBottom: 6 }}>
            Emails
          </Typography>
          <EmailUpdateForm
            type="email"
            emailData={hotelEmails}
            onChange={(data) => setHotelEmails(data)}
          />
          <div style={{ marginTop: 20 }}>
            <Typography variant="xs" style={{ marginBottom: 6, color: "red" }}>
              Invalid Emails
            </Typography>
            <InvalidEmailForm
              type="email"
              emailData={contactDetails?.email_hotel_contact_invalid_email}
              onChange={(data) => setInvalidEmails(data)}
              hotelName={hotelName}
              invalidEmails={invalidEmails}
            />
          </div>
        </div>

        </div>{/* end scrollable */}

        <Form.Item style={{ display: "flex", justifyContent: "flex-end", marginBottom: 0, marginTop: 16, borderTop: "1px solid #f0f0f0", paddingTop: 12 }}>
          <Button type="primary" onClick={handleSubmitHotelInfo} loading={isLoading}>
            Submit
          </Button>
        </Form.Item>
      </Form>
      {contextHolder}
    </div>
  );
}










